// extracted by mini-css-extract-plugin
export default {"root":"FloActionSelector_root__5Nhnb","menu":"FloActionSelector_menu__-tAuj","item":"FloActionSelector_item__+ctnt"};